import 'bootstrap/dist/css/bootstrap.min.css';
// import Layout from "./shared/Layout";
import './assets/css/styles.css'
import {Routes, Route} from 'react-router-dom';
import Home from './Home';
import About from './About';
import Projects from './Project';
import Testimonials from './Testimonials';
import Contact from './Contact';
import Skill from './Skill';

function App() {
  return (
    <Routes>
      <Route path='/' element={<Home/>}/>
      <Route path='/about' element={<About/>}/>
      <Route path='/projects' element={<Projects/>}/>
      <Route path='/testimonials' element={<Testimonials/>}/>
      <Route path='/contact' element={<Contact/>}/>
      <Route path='/skill' element={<Skill/>}/>
    </Routes>
  );
}

export default App;
